import { instance } from 'api/core';
import { CallbackObject } from 'api/core/get-page-function';

export const unmarkAsrsServerProduct = async (serverId: string, productId: string, callback: CallbackObject<void>) => {
  try {
    await instance.delete(`/catalog/asrs/${serverId}/products/${productId}`);
    callback.success();
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
